module.exports = __webpack_public_path__ + "media/images/digivent/lobby-d65d9b0949611a2a79bdeef32d4dab3e.jpg";